<div class="yellowMask">

    <div class="headerContainer">
        <div id="headerLogo"></div>

        <h1 style="
            font-size: 1.6rem;
            color: white;
            line-height: 85px;
            font-family: 'Roboto', helvetica, arial, sans-serif;
            float: left;
            margin-left: 15px;
        ">Kreditportal</h1>

        <button class="headerButton btn-yellow-white" (click)="fwHilfe()"><span class="hilfe"></span></button>
        <button class="headerButton btn-yellow-white" (click)="fwKautionsPage()"><span>Zur Kautions-Produktseite</span></button>
    </div>

    <div class="contentContainer">
        <h1>Registrierung abschließen</h1>

        @if (state === 'verifyEmail') {
            <div class="gridContainer formGrid loginGrid">
                <div class="row">
                    <div class="cell grid-100">
                        Ihre E-Mail-Adresse wird verifiziert...
                    </div>
                </div>
            </div>
        }

        @if (state === 'verifyUserWithEmail') {
            <div class="gridContainer formGrid loginGrid">
                <div class="row">
                    Bitte vergeben Sie ein Passwort für das Nutzerkonto.
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <input id="newPassword"
                               type="password"
                               name="f_account_passwort_neu1"
                               value=""
                               placeholder="Neues Passwort"
                               [(ngModel)]="passwordModel.password.value"
                               [class.error]="passwordModel.password.valid === false"
                               (blur)="validatePassword()"
                               (keyup)="onNewPasswordKeyUp($event)">
                        @if (passwordModel.password.valid === false) {
                            <div
                                class="errorMessage bottomMessage"
                                [innerHTML]="passwordModel.password.errorMsg"></div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <input id="newPasswordConfirm"
                               type="password"
                               name="f_account_passwort_neu2"
                               value=""
                               placeholder="Passwort wiederholen"
                               [(ngModel)]="passwordModel.passwordConfirm"
                               [class.error]="passwordModel.password.valid === false"
                               (blur)="validatePassword()"
                               (keyup)="onNewPasswordKeyUp($event)">
                        @if (passwordModel.password.valid === false) {
                            <div
                                class="errorMessage bottomMessage"
                                [innerHTML]="passwordModel.password.errorMsg"></div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <div>Das Passwort muss folgende Voraussetzungen erfüllen:</div>
                        <div class="pwChecklist">
                            <div [class.fulfilled]="pwCorrectNumChars">mind. 12 bis max. 40 Zeichen</div>
                            <div [class.fulfilled]="pwCorrectMajuscule">mind. ein Großbuchstabe</div>
                            <div [class.fulfilled]="pwCorrectMinuscule">mind. ein Kleinbuchstabe</div>
                            <div [class.fulfilled]="pwCorrectDigit">mind. eine Ziffer</div>
                            <div [class.fulfilled]="pwCorrectSpecialChar">mind. eins der Sonderzeichen <span style="font-family: monospace">!?&#64;()&lcub;&rcub;[]\/=~$%&amp;#*-+.,_</span></div>
                            <div class="violation" [hidden]="!passwordModel.password.value || pwCheckNoOtherChars">Das Passwort enthält nicht erlaubte Zeichen, zugelassen sind nur die zuvor aufgeführten Zeichen</div>
                            <div [class.fulfilled]="pwCorrectPasswordConfirm">Passwort und Wiederholung stimmen überein</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <elem-button buttonRole="PRIMARY" class="expand register-btn" [disabled]="btnIsLocked()" (click)="handlePasswortInput()">
                            Passwort vergeben
                        </elem-button>
                    </div>
                </div>
            </div>
        }

        @if (state === 'finished') {
            <div class="gridContainer formGrid loginGrid">
                <div class="row">
                    <div class="cell grid-100">
                        {{ finishedText }}
                    </div>
                    <div class="cell grid-100" style="margin-top: 3rem">
                        <elem-button buttonRole="PRIMARY" class="expand register-btn" (click)="handleLoginBtnClick()">
                            Zum Login
                        </elem-button>
                    </div>
                </div>
            </div>
        }

    </div>

    <extern-footer class="pageYellow"></extern-footer>

</div>

